"use client";

import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IntroductionToMOProtocolSystem() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="introduction-to-mo-protocol-system" className="bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <h1 className="font-default text-5xl md:text-7xl lg:text-[80px] leading-tight text-foreground mb-6 tracking-tight">
              The Protocol System
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed font-sans">
              Experience a new standard of clinical wellness. Our meticulously
              designed protocols integrate advanced medical science with
              holistic care, delivering measurable results and profound
              rejuvenation tailored to your unique biology.
            </p>
          </div>

          {}
          <div className="lg:col-span-5 w-full">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <AspectRatio ratio={3 / 4}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/clinical_wellness_protocol.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/clinical_wellness_protocol.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/clinical_wellness_protocol.png-wvc-sizes" alt="High-end clinical wellness facility" className="object-cover w-full h-full" loading="lazy" />
              </AspectRatio>
            </div>
          </div>
        </div>
      </div>
    </section>;
}